import { collections } from '@/mocks/yokaiManga';

export default function Collections() {
  return (
    <section id="collection" className="bg-paper-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mb-10 flex flex-col gap-2 md:mb-12">
          <p className="text-sm font-medium text-primary-600">一站式合集</p>
          <h2 className="font-serif text-2xl font-bold text-ink-900 md:text-3xl">妖精漫画大全合集</h2>
          <p className="max-w-2xl text-sm text-ink-500 md:text-base">
            按题材整理的全集合集入口，把同类型的经典与冷门作品集中管理，
            想要一次看个够，从这里开始。
          </p>
        </div>

        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 md:gap-6">
          {collections.map((col) => (
            <article
              key={col.id}
              className="group relative overflow-hidden rounded-2xl border border-paper-200"
            >
              <div className="relative h-64 w-full overflow-hidden md:h-72">
                <img
                  src={col.img}
                  alt={`${col.title}封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-900/80 via-ink-900/30 to-transparent"></div>
                <div className="absolute inset-x-0 bottom-0 p-5 md:p-6">
                  <p className="text-sm text-accent-300">{col.subtitle}</p>
                  <h3 className="mt-1 font-serif text-xl font-bold text-paper-50 md:text-2xl">
                    {col.title}
                  </h3>
                  <p className="mt-2 line-clamp-2 text-sm text-paper-100/85">{col.desc}</p>
                  <div className="mt-4 flex items-center gap-3">
                    <span className="rounded-full bg-accent-500 px-3 py-1 text-xs font-semibold text-ink-900">
                      {col.count}
                    </span>
                    <a
                      href="#hot"
                      className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-paper-50 px-4 py-1.5 text-sm font-medium text-ink-900 transition-colors hover:bg-accent-100"
                    >
                      进入合集
                      <i className="ri-arrow-right-line" aria-hidden="true"></i>
                    </a>
                  </div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}